import React from 'react';

function PaginationInfo(props) {
    return (
        <div className="tw-text-xs tw-text-charcoal-75">
            {$t('Showing {{from}} - {{to}} of {{total}}', {
                from: props.from || 0,
                to: props.to || 0,
                total: props.total || 0,
            })}
        </div>
    );
}

export default PaginationInfo;
